import axios from 'axios';

const client = axios.create({
  baseURL: process.env.REASONS_REPORT_LISTING,
  headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
  transformRequest: [(data, _headers) => JSON.stringify(data)]
});

export default client;
